Common.Views.Notify = Backbone.View.extend({
	tagName: 'div',
	className: 'b-notify',
	template: Handlebars.compile($('#block_notify').html()),
	delay: 5000,
	timeoutInterval: null,

	render: function(params) {
		this.$el
			.html(this.template(params || {}))
			.appendTo(Common.view.partials.$notify)
			.hide()
			.show('slow');
	},

	show: function(params) {
		if (!this.timeoutInterval) {
			this.render(params);

			if (params.delay !== Infinity) {
				this.timeoutInterval = setTimeout(this.remove.bind(this), params.delay || this.delay);
			}
		}
	},

	remove: function() {
		this.timeoutInterval = null;

		this.$el.hide('slow', function() {
			this.$el.remove();
		}.bind(this));
	}
});
